import general from "../general";
import { sortEncodeAndHash } from "./signFunc";

// 搜索链路kid获取 及 行为上报封装
const getKidCallback = async () => {
  const time = new Date().getTime().toString();

  let kid = "";
  await general.axios
    .post(
      "/v4/tracking/generate/kid",
      {},
      {
        headers: {
          sign: sortEncodeAndHash({
            timestamp: time,
          }),
          timestamp: time,
        },
      }
    )
    .then((res) => {
      console.log("获取kid进行链路---", res);
      kid = res.data.kid;
    })
    .catch((error) => {
      kid = "";
    });

  return kid;
};

const userClickReport = async (objData) => {
  const time = new Date().getTime().toString();

  general.axios
    .post("/v4/tracking/report/search", objData, {
      headers: {
        sign: sortEncodeAndHash({
          ...objData,
          timestamp: time,
        }),
        timestamp: time,
      },
    })
    .then(async (res) => {
      console.log("用户点击上报---", res);
    })
    .catch((error) => console.log("media-point " + error));
};

export { getKidCallback, userClickReport };
